"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _excluded = ["src", "size", "isPresentational"];

var ImageIcon = function ImageIcon(_ref) {
  var src = _ref.src,
      size = _ref.size,
      isPresentational = _ref.isPresentational,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], (0, _extends2["default"])({
    width: "auto",
    justifyContent: "center",
    alignItems: "center"
  }, props), src && /*#__PURE__*/_react["default"].createElement("img", {
    height: size,
    width: size,
    src: src,
    role: isPresentational ? "presentation" : null,
    alt: " "
  }));
};

ImageIcon.propTypes = (0, _extends2["default"])({}, _Flex["default"].propTypes, {
  size: _propTypes["default"].string,
  isPresentational: _propTypes["default"].bool
});
ImageIcon.defaultProps = {
  size: "24px",
  isPresentational: true
};
var _default = ImageIcon;
exports["default"] = _default;